import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=551b2343&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"
import style0 from "./Success.vue?vue&type=style&index=0&id=551b2343&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b2343",
  null
  
)

export default component.exports